export default __webpack_public_path__ + "static/media/address_image.3385d92e.svg";